// src/main.js — ConcrePro entry point
import './styles/main.css';
import { initApp } from './app.js';

// Register Service Worker (PWA)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      console.info('ConcrePro: SW no disponible en desarrollo');
    });
  });
}

// Boot
document.addEventListener('DOMContentLoaded', () => {
  initApp(document.getElementById('app'));
});
